<ng-container *ngIf="showFilters && !isServerError">
  <div class="calendar-navigation">
    <button class="no-style current-day" (click)="btnTodayClick()">
      <mat-icon [svgIcon]="'calendar-current'" class="square-icon current-day-icon"></mat-icon>
      <span class="current-day-label d-phone-none">{{widgetData.btnSelectTodayText}}</span>
    </button>

    <div class="month-selector">
      <button class="no-style prev" (click)="dayChange('prev')">
        <mat-icon [svgIcon]="'prev'" class="square-icon arrow-icon"></mat-icon>
      </button>
      <span>
        {{getCurrentDateForDisplay()}}
        <span *ngIf="LocalizationService.showHebrewElements()">
          |
          {{currentDate | hebrewMonth }}
        </span>  
      </span>
      <button class="no-style next" (click)="dayChange('next')">
        <mat-icon [svgIcon]="'next'" class="square-icon arrow-icon"></mat-icon>
      </button>
    </div>
  </div>

  <div class="filters-wrap d-phone-none">
    <div class="filters-label">{{widgetData.filtersTitle}}:</div>
    <div class="filters">
      <mat-checkbox
        *ngFor="let item of typeFilterItems"
        class="radio-view"
        [ngStyle]="{'--control-color': FiltersColorHelper.getStyleColor(item.color)}"
        [checked]="item.checked"
        (change)="typeFilterChange($event, item.value, item.valueArr)"
        [disabled]="isLoading"
        >
        {{ item.label }}
      </mat-checkbox>
    </div>
  </div>

  <div class="mobile-filters d-not-phone-none">
    <app-filter-item
      #typeFilter
      filterTitle="{{widgetData.filtersTitle}}"
      [filterItems]="typeFilterItems"
      [multi]="true"
      (setValue)="mobileTypeFilterChange($event)"
      (showFilterMobileDropdown)="closeOpenMobileFilter(true)"
      (closeFilterMobileDropdown)="closeOpenMobileFilter(false)"
    />
  </div>
</ng-container>

<div *ngIf="!isServerError" class="schedule-box">
  <div class="time-col">
    <div *ngFor="let timeCell of timeRange" class="cell">
      {{ timeCell < 10 && '0' + timeCell || timeCell }}:00
    </div>
  </div>

  <div class="schedule-content">
    <div class="row schedule-days">
      <app-schedule-col
          [data]="schedule[0]"
          [timeRange]="timeRange"
          [active]="true"
          [homeMode]="true"
          class="schedule-col"
          [noResultsTitle]="widgetData.noResultsTitle"
          [noResultsContent]="widgetData.noResultsText"
          [noResultsLink]="widgetData.noResultsLink"
          [noResultsLinkText]="widgetData.noResultsLinkText"
          [isLoading]="isLoading"
          [onlineClassText]="widgetData.onlineClassText"
          [cancelledClassText]="widgetData.cancelledClassText"
          [hibridClassText]="widgetData.hibridClassText"
          [notificationsHeaderText]="widgetData.lessonsNotificationsPopupHeaderText"
        />
    </div>
  </div>
</div>

<app-timeout-error-message *ngIf="isServerError"></app-timeout-error-message>